import { adminNotificationTemplateQueryKeys as e } from "./adminNotificationTemplateQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminNotificationsApi as n } from "@maat/api-notifications";
//#region src/notifications/admin/useAdminNotificationTemplateQuery.ts
var r = (r) => t({
	queryKey: e.detail(r),
	queryFn: () => n.getTemplate(r),
	enabled: !!r
});
//#endregion
export { r as useAdminNotificationTemplateQuery };
